import { Splide, SplideSlide } from "@splidejs/react-splide";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import PopularTrekCards from "../Popular Treks/PopularTrekCards";
import useResponsiveSplideOptions from "./useResponsiveSplideOptions";


export default function MultidayTour() {
  // const [data, setData] = useState([]);
  // useEffect(() => {
  //   const trekData = db
  //     .collection("All MultiDay")
  //     .get()
  //     .then((snapshot) => {
  //       let d = [];
  //       snapshot.docs.forEach((snap) => {
  //         d.push(snap.data());
  //         if (d.length === snapshot.docs.length) {
  //           setData(d);
  //         }
  //       });
  //     });
  // }, []);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const splideOptions = useResponsiveSplideOptions();
 
  useEffect(() => {
    const fetchMultiDayTours = async () => {
      try {
        const localData = JSON.parse(localStorage.getItem("multi-day-tours"));

        if (localData && Array.isArray(localData)) {
          setData(localData);
          setIsLoading(false);
        }

        const snapshot = await db.collection("All MultiDay").get();
        const fetchedData = snapshot.docs.map((doc) => doc.data());

        const isDataChanged = JSON.stringify(fetchedData) !== JSON.stringify(localData);

        if (isDataChanged) {
          localStorage.setItem("multi-day-tours", JSON.stringify(fetchedData));
          setData(fetchedData);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching MultiDay tours:", error);
        setIsLoading(false);
      }
    };

    fetchMultiDayTours();
  }, []);

  // Optional: add loader
  if (isLoading) return <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderTop: "3px solid #ff5e00 !important",
      margin: "0rem auto",
    }}
    className="loader"
  ></div>;

  return (
    <div>
      <div className="popularTreks">
        <div className="popularTreksHeading">
          {" "}
          <span style={{ color: "black" }}>Best</span> Multiday{" "}
          <span style={{ color: "black" }}>tours</span>
        </div>
        <div className="popularTreksDetails">
          Mixed with adventure and relaxation, choose a category of tour that is
          fully customizable and flexible.
        </div>
        <div className="popularTrekCards">
          
          <Splide
            options={splideOptions}
            aria-label="popular treks"
          >
            {data?.map((d) => (
              <SplideSlide>
                <PopularTrekCards id="multiday" data={d?.Details} />
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </div>
    </div>
  );
}
